import styled from '@emotion/styled';
import { device, responseFont } from '@landsbankinn/ui';

export const SwooshLink = styled.a<{ color: string }>`
  position: relative;
  font-family: ${(props) => props.theme.font.family};
  font-size: 15px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.primary};
  letter-spacing: 0.22px;
  text-transform: uppercase;
  text-align: left;
  line-height: 1.2em;
  margin-right: 10px;
  padding-bottom: 18px;
  padding-top: 4px;
  padding-right: 2px;
  min-height: 66px;
  max-width: 145px;
  cursor: pointer;
  overflow: hidden;
  &:after {
    position: absolute;
    bottom: 0;
    left: 0;
    display: block;
    content: '';
    width: 35px;
    background-color: ${(props) => props.color || '#FF8316'};
    height: 3px;
    transition: width 220ms ease-in-out;
    /* transform: translateY(2px); */
  }
  &:hover:after {
    /* transform: translateY(0px); */
    width: 100%;
  }

  @media (min-height: 800px) {
    ${responseFont(15, 18)}
    max-width: 160px;
  }

  @media ${device.mobile} {
    margin-right: 50px;
  }
`;
